import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../../components/Layout.js";
import { useLocation } from "react-router-dom";
import { apiFetch } from "../../api.js";
import Select from "react-select";

const PackageMasterDetailsDesign = () => {
  const allowAlphabets = (v) => v.replace(/[^a-zA-Z ]/g, "");
  const allowNumbers = (v) => v.replace(/[^0-9]/g, "");
  const navigate = useNavigate();
  const [EffectiveFromDate, setEffectiveFromDate] = useState("");
  const [EffectiveEndDate, setEffectiveEndDate] = useState("");
  const [BranchName, setBranchName] = useState("");
  const [BranchNameList, setBranchNameList] = useState([]);
  const [ModelName, setModelName] = useState("");
  const [ModelNameList, setModelNameList] = useState([]);
  const [NameOfPackage, setNameOfPackage] = useState("");
  const [CategoryName, setCategoryName] = useState("");
  const [CategoryNameList, setCategoryNameList] = useState([]);
  const [Quantity, setQuantity] = useState("");
  const [ApproxValue, setApproxValue] = useState("");
  const [DiscountPercentage, setDiscountPercentage] = useState("");
  const [DiscountAmount, setDiscountAmount] = useState("");
  const [CompulsoryChecked, setCompulsoryChecked] = useState(false);
  const [TotalQty, setTotalQty] = useState("");
  const [PackageAmount, setPackageAmount] = useState("");
  const [isEditing, setIsEditing] = useState(false);
  const [gridRows, setGridRows] = useState([]);
  const routerLocation = useLocation();
  const [ipAddress, setIpAddress] = useState("");
  const [serverIp] = useState(window.location.hostname);
  const storedUserInfo = JSON.parse(sessionStorage.getItem("userinfo")) || {};

  const customStyles = {
    control: (base) => ({
      ...base,
      minHeight: "45px",
      height: "45px",
      borderRadius: "6px",
      borderColor: "#ccc",
      boxShadow: "none",
      fontSize: "15px",
    }),
    valueContainer: (base) => ({
      ...base,
      height: "45px",
      padding: "0 12px",
      display: "flex",
      alignItems: "center",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: "45px",
    }),
    input: (base) => ({
      ...base,
      margin: 0,
      padding: 0,
    }),
  };

  useEffect(() => {
    fetchbranchList();
    fetchModelList();
    fetchCategoryList();
  }, []);
  //--------------------------------------Branchlist Fetch
  const fetchbranchList = async () => {
    try {
      const response = await apiFetch(
        "http://144.143.142.29:5000/api/branch/list",
      );
      const data = await response.json();
      setBranchNameList(data);
    } catch (error) {
      console.error("Error fetching Branch list:", error);
    }
  };
  //--------------------------------------ModelLsit Fetch
  const fetchModelList = async () => {
    try {
      const response = await apiFetch(
        "http://144.143.142.29:5000/api/model/list",
      );
      const data = await response.json();
      setModelNameList(data);
    } catch (error) {
      console.error("Error fetching model list:", error);
    }
  };
  //--------------------------------------Categorylist Fetch
  const fetchCategoryList = async () => {
    try {
      const response = await apiFetch(
        "http://144.143.142.29:5000/api/category/list",
      );
      const data = await response.json();
      setCategoryNameList(data);
    } catch (error) {
      console.error("Error fetching category list:", error);
    }
  };
  //--------------------------------------Ip address Fetch
  useEffect(() => {
    apiFetch("http://144.143.142.29:5000/api/get-ip")
      .then((res) => res.json())
      .then((data) => setIpAddress(data.ip))
      .catch(() => setIpAddress("0.0.0.0"));
  }, []);
  //--------------------------------------Add Button Working
  const handleAddRow = () => {
    if (!CategoryName || !Quantity || !ApproxValue || !DiscountPercentage) {
      alert("Please fill all fields before adding.");
      return;
    }
    const selectedCategory = CategoryNameList.find(
      (x) => x.value === CategoryName,
    );
    const discountAmt =
      (parseFloat(ApproxValue) * parseFloat(DiscountPercentage)) / 100;
    const newRow = {
      CategoryId: CategoryName,
      CategoryLabel: selectedCategory?.label || "",
      Quantity: parseFloat(Quantity),
      ApproxValue: parseFloat(ApproxValue),
      DiscountPercentage: parseFloat(DiscountPercentage),
      DiscountAmount: discountAmt,
      CompulsoryChecked,
      unq: null,
    };

    const updatedRows = [...gridRows, newRow];
    setGridRows(updatedRows);
    calculateTotals(updatedRows);
    setCategoryName("");
    setQuantity("");
    setApproxValue("");
    setDiscountPercentage("");
    setCompulsoryChecked(false);
  };
  //--------------------------------------Grid calculation Fetch
  const calculateTotals = (rows) => {
    let totalQty = 0;
    let totalAmount = 0;
    let totalDiscount = 0;
    rows.forEach((r) => {
      totalQty += r.Quantity;
      totalAmount += r.ApproxValue;
      totalDiscount += r.DiscountAmount;
    });

    setTotalQty(totalQty);
    setPackageAmount(totalAmount);
    setDiscountAmount(totalDiscount.toFixed(2));
  };
  //--------------------------------------Save Working
  const handleSave = async () => {
    try {
      const mainPayload = {
        BranchName,
        NameOfPackage,
        ModelName,
        EffectiveFromDate,
        EffectiveEndDate,
        DiscountAmount,
        userId: storedUserInfo.userId,
        ipAddress: ipAddress,
        serverIp: window.location.hostname,
      };
      const mainResponse = await apiFetch(
        `/api/package/saveMain`,
        { method: "POST", body: JSON.stringify(mainPayload) },
      );
      const mainRes = await mainResponse.json();
      const mainUnqid = mainRes.unqid;
      if (!mainUnqid) {
        alert("Main UNQID not returned!");
        return;
      }
      // CHILD ROWS
      const childRows = gridRows.map((row) => ({
        category: row.CategoryId,
        qty: row.Quantity,
        value: row.ApproxValue,
        compulsory: row.CompulsoryChecked ? "Y" : "N",
        discountPercent: row.DiscountPercentage,
        discountAmount: row.DiscountAmount,
      }));

      if (childRows.length > 0) {
        await apiFetch(`/api/package/saveChild`, {
          method: "POST",
          body: JSON.stringify({ mainUnqid, rows: childRows }),
        });
      }
      alert("Package Master Saved Successfully!");
      navigate("/PackageMasterGrid");
    } catch (error) {
      console.error("SAVE ERROR:", error);
      alert("Error saving package!");
    }
  };
  //--------------------------------------Exit Working
  const handleExit = () => {
    navigate("/PackageMasterGrid");
  };
  //--------------------------------------Edit Working
  useEffect(() => {
    if (routerLocation.state?.unq) {
      loadEditData(routerLocation.state.unq);
      setIsEditing(true);
    }
  }, []);

  const loadEditData = async (unq) => {
    try {
      const response = await apiFetch(`/api/package/edit`, {
        method: "POST",
        body: JSON.stringify({ unqid: unq }),
      });
      const res = await response.json();
      const main = res.data.main;
      const child = res.data.child;
      setNameOfPackage(main.sp_767);
      setModelName(main.sp_768);
      const formatDate = (d) => {
        if (!d) return "";
        const [day, month, year] = d.split("/");
        return `${year}-${month}-${day}`;
      };
      setEffectiveFromDate(formatDate(main.sp_769));
      setEffectiveEndDate(formatDate(main.sp_770));
      setDiscountAmount(main.sp_774);
      console.log(main);

      const rows = child.map((r) => ({
        CategoryId: r.wdd_unq,
        CategoryLabel: r.category,
        Quantity: r.qty,
        ApproxValue: r.approx_value,
        DiscountPercentage: r.discountpercentage,
        DiscountAmount: r.discount_amount,
        CompulsoryChecked: r.compulsory,
        unq: r.unq,
      }));
      setGridRows(rows);
      calculateTotals(rows);
    } catch (err) {
      console.error("❌ EDIT LOAD ERROR:", err);
    }
  };

  // ------------------------- UPDATE MAIN -------------------------
  const handleUpdate = async () => {
    try {
      const mainPayload = {
        unqid: routerLocation.state.unq,
        BranchName,
        NameOfPackage,
        ModelName,
        EffectiveFromDate,
        EffectiveEndDate,
        DiscountAmount,
        userId: storedUserInfo.userId,
        ipAddress,
        serverIp,
      };

      const mainResponse = await apiFetch(
        `/api/package/updateMain`,
        { method: "POST", body: JSON.stringify(mainPayload) },
      );
      await mainResponse.json();

      const childRows = gridRows.map((row) => ({
        p_unq: routerLocation.state.unq,
        category: row.CategoryId,
        qty: row.Quantity,
        value: row.ApproxValue,
        compulsory: row.CompulsoryChecked ? "Y" : "N",
        discountPercent: row.DiscountPercentage,
        discountAmount: row.DiscountAmount,
        unq: row.unq || "",
      }));

      await apiFetch(`/api/package/updateChild`, {
        method: "POST",
        body: JSON.stringify({ rows: childRows }),
      });

      alert("Package updated successfully!");
      navigate("/PackageMasterGrid");
    } catch (err) {
      console.error("❌ UPDATE ERROR", err);
      alert("Error updating data!");
    }
  };

  //--------------------------------------Style
  const sectionHeaderStyle = {
    backgroundColor: "#f8bcbc",
    color: "#000",
    padding: "12px 15px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "15px",
    borderRadius: "4px",
  };

  const buttonContainerStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "12px",
    flexWrap: "wrap", // mobile friendly
    width: "100%",
    marginTop: "20px",
    position: "relative",
    zIndex: 10,
  };

  const buttonStyle = (bgColor) => ({
    minWidth: "120px", // ✅ same width everywhere
    height: "42px",
    padding: "0 20px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    cursor: "pointer",
    fontWeight: "bold",
    whiteSpace: "nowrap", // ✅ no text breaking
  });

  return (
    <Layout>
      <div className="page-container">
        <div className="container">
          <div className="header">PACKAGE MASTER</div>

          {/* ---------------- FORM ROW 1 ---------------- */}
          <div className="form-row">
            <div className="form-column">
              <label>Branch</label>
              <Select
                options={BranchNameList}
                value={
                  BranchNameList.find((o) => o.value === BranchName) || null
                }
                onChange={(selected) => setBranchName(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Branch"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Name Of Package</label>
              <input
                type="text"
                value={NameOfPackage}
                onChange={(e) =>
                  setNameOfPackage(allowAlphabets(e.target.value))
                }
              />
            </div>
            <div className="form-column">
              <label>Model Name</label>
              <Select
                options={ModelNameList}
                value={ModelNameList.find((o) => o.value === ModelName) || null}
                onChange={(selected) => setModelName(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Model"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Effective From</label>
              <input
                type="date"
                value={EffectiveFromDate}
                onChange={(e) => setEffectiveFromDate(e.target.value)}
              />
            </div>

            <div className="form-column">
              <label>End Date</label>
              <input
                type="date"
                value={EffectiveEndDate}
                onChange={(e) => setEffectiveEndDate(e.target.value)}
              />
            </div>
          </div>
          <div className="header1">Add New Package</div>
          <div className="form-row">
            <div className="form-column">
              <label>Category</label>
              <Select
                options={CategoryNameList}
                value={
                  CategoryNameList.find((o) => o.value === CategoryName) || null
                }
                onChange={(selected) => setCategoryName(selected?.value || "")}
                styles={customStyles}
                placeholder="Select Category"
                isSearchable
                menuPortalTarget={document.body}
                menuPosition="fixed"
              />
            </div>
            <div className="form-column">
              <label>Quantity</label>
              <input
                type="text"
                value={Quantity}
                onChange={(e) => setQuantity(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Approx Value</label>
              <input
                type="text"
                value={ApproxValue}
                onChange={(e) => setApproxValue(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Discount Percentage</label>
              <input
                type="text"
                value={DiscountPercentage}
                onChange={(e) =>
                  setDiscountPercentage(allowNumbers(e.target.value))
                }
              />
            </div>
            <div
              className="form-column"
              style={{ marginTop: "22px", alignItems: "center" }}
            >
              <button type="button" className="btn-blue" onClick={handleAddRow}>
                Add
              </button>
            </div>
          </div>
          {/* ---------------- TABLE ---------------- */}
          <div className="table-container">
            <div className="container">
              <table>
                <thead>
                  <tr>
                    <th>S.N</th>
                    <th>Category</th>
                    <th>Quantity</th>
                    <th>Approx Value</th>
                    <th>Discount Percentage</th>
                    <th>Discount Amount</th>
                    <th>Compulsory</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {gridRows.map((row, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{row.CategoryLabel}</td>

                      <td>{row.Quantity}</td>
                      <td>{row.ApproxValue}</td>
                      <td>{row.DiscountPercentage}</td>
                      <td>{row.DiscountAmount}</td>
                      <td>
                        <input
                          type="checkbox"
                          checked={row.CompulsoryChecked}
                          onChange={() => {
                            const updated = [...gridRows];
                            updated[index].CompulsoryChecked =
                              !updated[index].CompulsoryChecked;
                            setGridRows(updated);
                          }}
                        />
                      </td>

                      <td>
                        <button
                          className="delete-btn"
                          onClick={() => {
                            const updated = gridRows.filter(
                              (_, i) => i !== index,
                            );
                            setGridRows(updated);
                            calculateTotals(updated);
                          }}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="form-row">
            <div className="form-column">
              <label>Total Qty</label>
              <input
                type="text"
                value={TotalQty}
                onChange={(e) => setTotalQty(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Package Amount</label>
              <input
                type="text"
                value={PackageAmount}
                onChange={(e) => setPackageAmount(allowNumbers(e.target.value))}
              />
            </div>
            <div className="form-column">
              <label>Discount Amount</label>
              <input
                type="text"
                value={DiscountAmount}
                onChange={(e) =>
                  setDiscountAmount(allowNumbers(e.target.value))
                }
              />
            </div>
          </div>
          {/* ---------------- BUTTONS ---------------- */}
          <div style={buttonContainerStyle}>
            {!isEditing && (
              <button style={buttonStyle("#4CAF50")} onClick={handleSave}>
                Save
              </button>
            )}

            {isEditing && (
              <button
                style={buttonStyle("#2e20abff")}
                type="button"
                onClick={handleUpdate}
              >
                Update
              </button>
            )}

            <button style={buttonStyle("#ab2025")} onClick={handleExit}>
              Exit
            </button>
          </div>
        </div>
      </div>

      {/* ----------------------------------------------------
            CSS EXACTLY LIKE INSURANCE MASTER / RATE MASTER
      ---------------------------------------------------- */}
      <style>
        {`
/* ===========================
   react-select fix
=========================== */
.rs__menu-portal {
  z-index: 9999 !important;
}

/* ===========================
   PAGE LAYOUT
=========================== */
.page-container {
  width: 100%;
  min-height: 100vh;
  background: #f4f6f8;
  display: flex;
  justify-content: center;
  padding: 12px;
  box-sizing: border-box;
}

.container {
  width: 100%;
  max-width: 100%;
  background: #fff;
  border-radius: 8px;
  padding: 18px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  box-sizing: border-box;
}

/* ===========================
   HEADERS
=========================== */
.header,
.header1 {
  text-align: center;
  font-size: 1.6rem;
  font-weight: 700;
  padding: 14px;
  background: linear-gradient(90deg, #8B1E3F, #8B1E3F);
  color: #fff;
  border-radius: 6px;
  margin-bottom: 20px;
}

.header1 {
  height: auto;
}

/* ===========================
   FORM GRID (FIXED)
=========================== */
.form-row {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 16px;
  margin-bottom: 16px;
}

.form-column {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 6px;
}

/* ===========================
   INPUTS (FULL WIDTH FIX)
=========================== */
input,
select {
  height: 40px !important;
  width: 100% !important;
  padding: 8px 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  font-size: 14px;
  box-sizing: border-box;
}

input[type="date"] {
  padding-right: 35px;
}

/* ===========================
   TABLE
=========================== */
.table-container {
  overflow-x: auto;
  margin-top: 22px;
  border: 1px solid #ddd;
  border-radius: 6px;
}

table {
  width: max-content;
  min-width: 100%;
  border-collapse: collapse;
  font-size: 13px;
  table-layout: fixed;
}

th {
  background: #f8bcbc;
  padding: 10px;
  border: 1px solid #ccc;
  white-space: nowrap;
  text-align: center;
  position: sticky;
  top: 0;
}

td {
  border: 1px solid #ccc;
  padding: 6px;
  text-align: center;
  min-width: 110px;
}

/* ===========================
   BUTTONS
=========================== */
.button-container {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 22px;
  flex-wrap: wrap;
}

.btn-save {
  background: #4caf50;
  color: #fff;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
}

.btn-blue {
  background: hsla(234, 96%, 19%, 1.00);
  color: #fff;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  width: 120px;        /* ✅ same as Save & Exit */
  max-width: 120px;
}

.btn-exit {
  background: #a20d0d;
  color: #fff;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  font-weight: 600;
  cursor: pointer;
}

.delete-btn {
  background: #c62828;
  color: #fff;
  border: none;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
}

/* ===========================
   RESPONSIVE BREAKPOINTS
=========================== */

/* Tablet */
@media (max-width: 992px) {
  .form-row {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* Mobile */
@media (max-width: 480px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }

  .button-container button {
    flex: 1;
  }

  .header,
  .header1 {
    font-size: 1.3rem;
  }
}
`}
      </style>
    </Layout>
  );
};

export default PackageMasterDetailsDesign;
